/** coco+ の下部ナビ「お気に入り」ページ（お気に入りの近況） */
export const favoritesPage = {
  title: "お気に入り",
  notification: "お知らせ",
  search: "お気に入りを検索",
  recent: {
    heading: "お気に入りの近況",
    lead: "お気に入りの女の子の今と、24時間以内の活動をチェック",
    empty: "当てはまるお気に入りの女の子はいません",
    noBookmark: "お気に入りに登録した子がまだいません",
    noBookmarkLead: "プロフィールの⭐️でお気に入り登録ができます",
    goDiscover: "女の子をさがす",
    noMatch: "条件に合うお気に入りの女の子はいません",
    noMatchLead: "検索条件を変えるか、絞り込みを解除してください",
    error: "お気に入りの近況を読み込めませんでした",
  },
  filters: {
    all: "すべて",
    online: "オンライン",
    live: "配信",
    board: "掲示板",
    flea: "出品",
  },
  /** カードの種類ラベル（has_online / has_live / has_board / has_flea） */
  kind: {
    online: "オンライン",
    live: "配信",
    board: "掲示板",
    flea: "出品",
  },
  meta: {
    /** 「5分前にアクティブ」 */
    lastActivity: (args: { time: string }) => `${args.time}にアクティブ`,
  },
  nameSan: (args: { name: string }) => `${args.name}さん`,
} as const;
